import * as Sentry from '@sentry/react';
import { logger } from 'utils/logger';

export const replaceInviteLinkDomain = (originalUrl: string, baseDomain?: string): string => {
  if (!baseDomain) {
    return originalUrl;
  }

  try {
    const originalUrlObj = new URL(originalUrl);
    originalUrlObj.host = baseDomain;

    return originalUrlObj.toString();
  } catch (error) {
    logger.remote().error('Failed to replace invite link domain:', error);
    Sentry.captureException(error);
    return originalUrl;
  }
};
